import createSelector from 'lib/createSelector'
import isOrganicSearch from 'lib/isOrganicSearch'

export const hasOrganicReferrer = createSelector(
  (state: App.State) => state.config.referrer,
  (referrer) => isOrganicSearch(referrer),
)

export const isAndroidDevice = createSelector(
  (state: App.State) => state.config.userAgent,
  (userAgent) => {
    return userAgent.osName.includes('Android')
  },
)

export const isIOSDevice = createSelector(
  (state: App.State) => state.config.userAgent,
  (userAgent) => {
    // ipad uses `Mac OS` user agent
    // iphone uses `iOS` user agent
    return userAgent.osName === 'iOS' || userAgent.osName === 'Mac OS'
  },
)

export const isIOSMobile = createSelector(
  (state: App.State) => state.config.userAgent,
  (userAgent) => {
    return userAgent.osName === 'iOS'
  },
)

export const isMobileDevice = createSelector(
  isAndroidDevice,
  isIOSMobile,
  (isAndroid, isIOS) => isAndroid || isIOS,
)

export const isHeadlessMode = createSelector(
  (state: App.State) => state.config.headlessMode,
  (headlessMode) => headlessMode,
)

export const isMobileApp = createSelector(
  isMobileDevice,
  isHeadlessMode,
  (isMobileDevice, isHeadlessMode) => isMobileDevice && isHeadlessMode,
)
